import client from './client';

// ============================================================
// H2：平台授权状态（私有化离线 license；公开只读）
// ============================================================
export interface LicenseStatus {
  mode: 'saas' | 'private';
  status: 'not-required' | 'valid' | 'grace' | 'missing' | 'expired' | 'invalid';
  licensed: boolean;
  readonly: boolean;
  reason?: string;
  tenantName?: string;
  features?: string[];
  expiresAt?: number;
  graceEndsAt?: number;
  source: string;
}

export async function getLicenseStatus(): Promise<LicenseStatus | null> {
  try {
    const { data } = await client.get('/license/status');
    return data ?? null;
  } catch {
    return null;
  }
}
